import React from 'react';
import './Button.css';

const Button = ({ icon, text, onClick, type = 'button', disabled }) => {
  return (
    <button
      type={type}
      className='button_div1'
      onClick={onClick}
      disabled={disabled}
      style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      {icon && <img src={icon} alt="" className='icon' />}
      <h4 className='button_text'>{text}</h4>
    </button>
  );
};

export default Button;